import { useState } from "react";
import { Award as AwardIcon } from "lucide-react";
import { AWARDS } from "../data/awards";

/** Hidden entirely while AWARDS is empty — this ticket's own AC explicitly asks for no empty state, not this project's usual "coming soon" panel. */
export default function AwardsShowcase() {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  if (AWARDS.length === 0) return null;

  const sorted = [...AWARDS].sort((a, b) => b.year - a.year);

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {sorted.map((award) => {
        const expanded = expandedId === award.id;
        return (
          <button
            key={award.id}
            type="button"
            onClick={() => setExpandedId(expanded ? null : award.id)}
            aria-expanded={expanded}
            className="rounded-2xl bg-white p-5 text-left shadow-sm ring-1 ring-ocean-900/5 dark:bg-ocean-900 dark:ring-white/10"
          >
            <div className="flex items-start gap-3">
              {award.badgeImageUrl ? (
                <img
                  src={award.badgeImageUrl}
                  alt=""
                  loading="lazy"
                  className="h-10 w-10 shrink-0 object-contain"
                />
              ) : (
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-400/15 text-teal-500 dark:bg-teal-400/20 dark:text-teal-300">
                  <AwardIcon className="h-5 w-5" strokeWidth={1.5} />
                </div>
              )}
              <div className="min-w-0">
                <p className="font-display font-semibold text-ocean-950 dark:text-foam-50">{award.name}</p>
                <p className="text-xs text-ocean-800/60 dark:text-foam-100/60">
                  {award.awardingBody} · {award.year} · {award.category}
                </p>
              </div>
            </div>
            {expanded && award.description && (
              <p className="mt-3 text-sm leading-relaxed text-ocean-800/70 dark:text-foam-100/70">{award.description}</p>
            )}
          </button>
        );
      })}
    </div>
  );
}
